{
  "nav": {
    "indicadors": "Indicadors",
    "informes": "Informes",
    "tracabilitat": "Traçabilitat",
    "auditoria": "Auditoria",
    "monitoratge": "Monitoratge d'enviaments",
    "recurrents": "Recurrents",
    "generador": "Generador d'informes",
    "informeActivacio": "Informe d'activació",
    "detallTracabilitat": "Traçabilitat"
  },
  "titols": {
    "indicadors": "Quadre d'indicadors",
    "informes": "Informes",
    "tracabilitat": "Traçabilitat d'una activació",
    "auditoria": "Registre d'auditoria",
    "monitoratge": "Monitoratge d'enviaments",
    "recurrents": "Incidències recurrents",
    "generador": "Generador d'informes",
    "informeActivacio": "Informe de detall d'activació",
    "detallTracabilitat": "Traçabilitat d'una activació"
  },
  "comu": {
    "periode": "Període",
    "departament": "Departament",
    "area": "Àrea",
    "totsDepartaments": "Tots els departaments",
    "totesArees": "Totes les àrees",
    "segons": "{{n}} s",
    "minuts": "{{n}} min",
    "hores": "{{n}} h",
    "tendencia": "{{signe}}{{n}} %",
    "exporta": "Exporta",
    "carregant": "Carregant…",
    "senseDades": "No hi ha dades per al període seleccionat",
    "servei": "Servei",
    "zona": "Zona",
    "senseZona": "Sense zona",
    "veureTot": "Veure-ho tot",
    "torna": "Torna",
    "elimina": "Elimina",
    "rang": "{{desde}} – {{fins}}",
    "edita": "Edita"
  },
  "periodes": {
    "SETMANA": "Setmana",
    "MES": "Mes",
    "TRIMESTRE": "Trimestre"
  },
  "periodicitats": {
    "SETMANAL": "Setmanal (dilluns 7:00)",
    "MENSUAL": "Mensual (dia 1, 7:00)",
    "TRIMESTRAL": "Trimestral (dia 1, 7:00)"
  },
  "tipusProgramat": {
    "GLOBAL": "Informe global",
    "COMPARATIVA": "Comparativa per equips",
    "ACTIVACIONS": "Activacions",
    "RECURRENTS": "Incidències recurrents",
    "INDICADORS": "Indicadors"
  },
  "tipusInforme": {
    "DETALL": {
      "nom": "Detall d'activació",
      "desc": "Destinataris, canals, marques de temps, confirmacions, missatges i accions"
    },
    "GLOBAL": {
      "nom": "Informe global",
      "desc": "Activacions, temps i compliment del període"
    },
    "EQUIP": {
      "nom": "Comparativa per equip",
      "desc": "Indicadors per departament i àrea"
    },
    "AUDITORIA": {
      "nom": "Auditoria i traçabilitat",
      "desc": "Cronologia unificada i evidències d'una activació"
    }
  },
  "seccions": {
    "DESTINATARIS": "Destinataris",
    "CANALS": "Canals",
    "TEMPS": "Marques de temps",
    "MISSATGES": "Missatges",
    "ACCIONS": "Accions"
  },
  "events": {
    "ACTIVACIO_CREADA": "Activació creada",
    "DESTINATARI_ENVIAT": "Enviat",
    "DESTINATARI_LLIURAT": "Lliurat",
    "DESTINATARI_LLEGIT": "Llegit",
    "DESTINATARI_CONFIRMAT": "Confirmat",
    "DESTINATARI_ACCEPTAT": "Acceptat",
    "ENVIAMENT": "Enviament",
    "MISSATGE": "Missatge ({{tipus}})",
    "ACCIO": "Acció ({{tipus}})",
    "ESCALAT": "Escalat",
    "ACTIVACIO_TANCADA": "Activació tancada"
  },
  "indicadors": {
    "PRIMERA_CONFIRMACIO": "Primera confirmació",
    "ESCALAT_NIVELL": "Escalat al nivell {{n}}",
    "RESOLUCIO": "Resolució"
  },
  "w40": {
    "indicador": "Indicador",
    "valor": "Valor",
    "mitjana": "Mitjana",
    "perPeriode": "Activacions per període",
    "perTipus": "Distribució per tipus",
    "perServei": "Activacions per servei",
    "perZona": "Per zona",
    "recurrents": "Incidències recurrents",
    "kpi": {
      "activacions": "Activacions totals",
      "primeraConfirmacio": "1a confirmació (mitjana)",
      "escalat": "Escalat (mitjana)",
      "resolucio": "Resolució (mitjana)",
      "confirmacio": "Confirmació",
      "noLliurats": "Avisos no lliurats",
      "ambEscalat": "Amb escalat",
      "compliment": "Compliment de temps"
    },
    "vsAnterior": "{{valor}} vs. període anterior",
    "punts": "{{valor}} pp",
    "setmanaN": "Setm. {{n}}",
    "barraTitol": "{{periode}}: {{n}} activacions",
    "ambPercentatge": "{{n}} ({{pct}})",
    "perDia": "Activacions per dia",
    "perSetmana": "Activacions per setmana",
    "percentTotal": "% del total",
    "llegenda": "{{nom}} · {{pct}}",
    "recurrentsTop": "Incidències recurrents (top 3)"
  },
  "w41": {
    "programa": "Programa l'enviament",
    "nou": "Nou informe",
    "comparativa": "Comparativa per departament i àrea",
    "equip": "Departament · Àrea",
    "tendencia": "Tendència",
    "activacions": "Activacions del període",
    "informe": "Informe",
    "programats": "Informes programats",
    "senseProgramats": "No hi ha informes programats",
    "ultimaExecucio": "Darrera execució: {{data}}",
    "actiu": "Actiu",
    "inactiu": "Inactiu",
    "vsAnterior": "vs. {{desde}} – {{fins}}",
    "primeraConfirmacio": "1a confirmació",
    "resolucio": "Resolució",
    "confirmacio": "% confirmació",
    "peu": "Tendència calculada sobre el nombre d'activacions respecte del mateix període anterior. Font: registre d'activacions."
  },
  "w42": {
    "tipus": "Tipus d'informe",
    "filtres": "Filtres",
    "activacio": "Activació",
    "activacioPlaceholder": "ID o codi (ACT-2026-0001)",
    "desde": "Des de",
    "fins": "Fins a",
    "format": "Format",
    "seccions": "Seccions",
    "programacio": "Programació periòdica",
    "programar": "Enviament periòdic",
    "noProgramable": "Aquest tipus d'informe no es pot programar",
    "nom": "Nom",
    "periodicitat": "Periodicitat",
    "destinataris": "Destinataris (correus separats per comes)",
    "destinatarisPlaceholder": "nom@bonarea.com, altre@bonarea.com",
    "desat": "Programació desada",
    "desaProgramacio": "Desa la programació",
    "genera": "Genera l'informe",
    "errors": {
      "activacio": "Indica una activació",
      "descarrega": "No s'ha pogut descarregar l'informe",
      "nom": "El nom és obligatori",
      "destinataris": "Indica com a mínim un correu vàlid",
      "camp": "Camp no vàlid: {{camp}}",
      "desa": "No s'ha pogut desar la programació"
    },
    "titolEdicio": "Edita l'informe programat",
    "ambit": "Departament / àrea",
    "formatProgramacio": "Format i programació",
    "recarrega": "Torna a carregar"
  },
  "w43": {
    "descarrega": "Descarrega {{format}}",
    "descarregaPdf": "Descarrega el PDF",
    "subtitol": "Informe de detall d'activació",
    "generat": "Generat el {{data}}",
    "dades": "Dades de l'activació",
    "activador": "Persona activadora",
    "inici": "Inici de l'incident",
    "canals": "Canals",
    "descripcio": "Descripció",
    "proves": "Proves realitzades",
    "itcau": "Incidència ITCAU",
    "confirmats": "Destinataris i confirmacions ({{confirmats}}/{{total}})",
    "persona": "Persona",
    "bloc": "Bloc",
    "enviat": "Enviat",
    "lliurat": "Lliurat",
    "llegit": "Llegit",
    "confirmat": "Confirmat",
    "estat": "Estat",
    "tancament": "Tancament",
    "motiu": "Motiu",
    "tancada": "Tancada",
    "comentari": "Comentari",
    "peu": "Document generat per CAI — Centre d'Alertes i Incidències · cai.ba-tech.net",
    "titol": "Informe de detall · {{codi}}",
    "oberta": "Oberta",
    "durada": "Durada total",
    "cronologia": "Cronologia",
    "metadades": "Metadades",
    "generatEl": "Generat el",
    "generatPer": "Generat per",
    "formatPdf": "PDF",
    "classificacio": "Classificació",
    "usIntern": "Ús intern"
  },
  "w44": {
    "filtre": "Filtre per categoria",
    "filtres": {
      "TOTS": "Tots",
      "PERMISOS": "Permisos",
      "CONFIGURACIO": "Configuració",
      "USUARIS": "Usuaris",
      "GUARDIES": "Guàrdies",
      "DOCUMENTACIO": "Documentació",
      "ACTIVACIONS": "Activacions"
    },
    "resultat": "Resultat",
    "totsResultats": "Tots els resultats",
    "resultats": {
      "OK": "Correcte",
      "ERROR": "Error",
      "DENEGAT": "Denegat"
    },
    "darrers30": "Últims 30 dies",
    "persona": "Persona",
    "data": "Data i hora",
    "accio": "Acció",
    "objecte": "Objecte",
    "ip": "Adreça IP",
    "total_one": "{{count}} registre",
    "total_other": "{{count}} registres",
    "anterior": "Anterior",
    "seguent": "Següent",
    "pagina": "Pàgina {{n}} de {{total}}",
    "cerca": "Cerca a l'auditoria…",
    "sistema": "Sistema"
  },
  "w45": {
    "cerca": "Cerca una activació",
    "cercaPlaceholder": "ID, codi (ACT-2026-0001) o títol",
    "cercar": "Cerca",
    "resultats": "Resultats",
    "recents": "Activacions recents",
    "informe": "Informe",
    "exporta": "Exporta com a evidència",
    "esdeveniments": "Esdeveniments",
    "enviaments": "Enviaments",
    "confirmacions": "Confirmacions",
    "missatges": "Missatges",
    "escalats": "Escalats",
    "complertsKpi": "Temps complerts",
    "complerts": "{{n}} / {{total}}",
    "cronologia": "Cronologia unificada",
    "temps": "Temps compromesos vs. reals",
    "compromes": "Compromès",
    "real": "Real",
    "compliment": "Compliment",
    "complert": "Complert",
    "noComplert": "No complert",
    "pendent": "Pendent",
    "titol": "Traçabilitat completa · {{codi}}",
    "objectiu": "(objectiu {{temps}})",
    "resum": "Resum d'evidències",
    "lliuraments": "Lliuraments",
    "lectures": "Lectures"
  },
  "w46": {
    "canal": "Canal",
    "totsCanals": "Tots els canals",
    "cua": "Cua pendent",
    "p50": "Latència P50",
    "p95": "Latència P95",
    "ms": "{{n}} ms",
    "enviats": "Enviats (24 h)",
    "darreres24": "Darreres 24 h · finestra mòbil",
    "fallits": "Fallits (24 h)",
    "exit": "Taxa d'èxit (24 h)",
    "passarelles": "Passarel·les",
    "estats": {
      "OK": "Operativa",
      "DEGRADAT": "Degradada",
      "KO": "Caiguda",
      "NO_CONFIGURAT": "No configurada"
    },
    "resum": "{{enviats}} enviats · {{fallits}} fallits",
    "errors": "Errors recents",
    "senseErrors": "No hi ha errors d'enviament recents",
    "data": "Data i hora",
    "estat": "Estat",
    "codi": "Codi",
    "detall": "Detall",
    "s": "{{n}} s",
    "cuaTitol": "Cua d'enviaments",
    "pendents_one": "{{count}} pendent",
    "pendents_other": "{{count}} pendents",
    "latencia": "Latència d'entrega",
    "global": {
      "OK": "Totes les passarel·les operatives",
      "DEGRADAT": "Degradació parcial",
      "KO": "Passarel·la caiguda",
      "NO_CONFIGURAT": "Hi ha passarel·les sense configurar"
    }
  },
  "w47": {
    "buit": "No s'han detectat incidències recurrents",
    "activacions_one": "{{count}} activació",
    "activacions_other": "{{count}} activacions",
    "grafic": "Activacions per servei",
    "taula": "Serveis amb més activacions",
    "patrons": "Patrons detectats",
    "sensePatrons": "No s'han detectat patrons rellevants",
    "patro": {
      "MATEIX_SERVEI": {
        "titol": "{{servei}}: {{n}} activacions recurrents",
        "recomanacio": "Revisa la causa arrel amb el tècnic expert i actualitza la documentació del servei."
      },
      "MATEIXA_ZONA": {
        "titol": "Zona {{zona}}: {{n}} activacions recurrents",
        "recomanacio": "Valora mesures preventives a la zona i avisos preventius als usuaris a informar."
      },
      "CONCENTRACIO": {
        "titol": "{{servei}} concentra el {{pct}} % de les recurrències",
        "recomanacio": "Prioritza aquest servei en el pla de millora i revisa el circuit d'escalat."
      }
    },
    "barraTitol": "{{servei}}: {{count}}",
    "etiquetes": {
      "recurrent": "Recurrent",
      "vigilar": "A vigilar"
    },
    "recomanacio": "Recomanació: {{text}}"
  },
  "tipusAccio": {
    "CREADA": "Activació creada",
    "ENVIADA": "Notificació enviada",
    "CONFIRMADA": "Confirmació",
    "ACCEPTADA": "Gestió acceptada",
    "REENVIADA": "Reenviament",
    "ESCALADA": "Escalat",
    "EXPERT_ACTIVAT": "Expert activat",
    "NOTA": "Nota afegida",
    "ITCAU_VINCULAT": "Vinculada a ITCAU",
    "TANCADA": "Tancament",
    "DOCUMENT_CONSULTAT": "Consulta de documentació"
  },
  "tipusMissatge": {
    "TEXT": "text",
    "MISSATGE": "text",
    "ACTUALITZACIO": "actualització",
    "RISC": "risc",
    "AFECTACIO": "afectació",
    "NOVETAT": "novetat",
    "RECURSOS": "recursos",
    "SISTEMA": "sistema",
    "FINALITZACIO": "finalització"
  },
  "auditoriaAccions": {
    "permis_denegat": "Accés denegat",
    "rol_permisos_desar": "Canvi de permisos",
    "usuari_rol_assignar": "Assignació de rol",
    "usuari_rol_revocar": "Revocació de rol",
    "usuari_sync_entra": "Sincronització amb Entra ID",
    "document_alta": "Pujada de document",
    "document_escaneig": "Anàlisi de seguretat de document",
    "document_retirar": "Retirada de document",
    "document_substituir": "Substitució de document",
    "document_edicio": "Actualització de metadades de document",
    "activacio_alta": "Alta d'activació",
    "activacio_tancar": "Tancament d'activació",
    "activacio_escalar": "Escalat d'activació",
    "activacio_expert": "Activació d'expert",
    "activacio_itcau": "Vinculació ITCAU",
    "activacio_destinataris": "Destinataris afegits",
    "servei_usuaris_informar_import": "Importació d'usuaris a informar",
    "rotacio_generar": "Generació de rotació",
    "sollicitud_aprovar": "Aprovació de canvi de torn",
    "sollicitud_rebutjar": "Rebuig de canvi de torn",
    "config_modificar": "Canvi de configuració",
    "configuracio_modificar": "Canvi de configuració"
  },
  "auditoriaVerbs": {
    "alta": "Alta",
    "baixa": "Baixa",
    "modificar": "Modificació",
    "edicio": "Modificació",
    "eliminar": "Eliminació",
    "desar": "Desament",
    "assignar": "Assignació",
    "revocar": "Revocació",
    "aprovar": "Aprovació",
    "rebutjar": "Rebuig",
    "cancellar": "Cancel·lació",
    "generar": "Generació",
    "import": "Importació",
    "retirar": "Retirada",
    "substituir": "Substitució",
    "tancar": "Tancament",
    "escalar": "Escalat",
    "denegat": "Accés denegat"
  },
  "auditoriaEntitats": {
    "configuracio": "Configuració",
    "rol": "Rol",
    "usuari": "Usuari",
    "activacio": "Activació",
    "app_versio": "Versió de l'app",
    "calendari": "Calendari",
    "circuit_escalat": "Circuit d'escalat",
    "document": "Document",
    "document_versio": "Versió de document",
    "politica_fitxers": "Política de fitxers",
    "grup": "Grup",
    "informe_programat": "Informe programat",
    "missatge_admin": "Missatge d'administració",
    "area": "Àrea",
    "departament": "Departament",
    "servei": "Servei",
    "zona": "Zona",
    "plantilla": "Plantilla",
    "rotacio": "Rotació",
    "sollicitud_canvi_torn": "Sol·licitud de canvi de torn",
    "tipus_avis": "Tipus d'avís",
    "torn": "Torn"
  }
}
